import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "react-feather";
import { useTheme } from "../theme/ThemeContext";
import { API_BASE, apiFetch } from "../api";
import ExpenseAnalysis from "./ExpenseAnalysis";
import { useBudgets } from "./useBudgets";

// The fixed-vs-random spending analysis, compact, for the desktop Dashboard. The
// full version (with the by-type breakdowns) is on the Analysis page.
const SpendingAnalysisCard = () => {
  const { tokens, fonts } = useTheme();
  const [bills, setBills] = useState(null);
  const [error, setError] = useState(false);
  const { budgets } = useBudgets();

  useEffect(() => {
    apiFetch(`${API_BASE}/bills`)
      .then((res) => (res.ok ? res.json() : Promise.reject()))
      .then(setBills)
      .catch(() => setError(true));
  }, []);

  return (
    <section style={{ marginBottom: 24 }}>
      <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", marginBottom: 12 }}>
        <h2 style={{ margin: 0, fontFamily: fonts.display, fontSize: 18, color: tokens.textPrimary }}>Spending analysis</h2>
        <Link to="/analysis" style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 13, fontWeight: 600, color: tokens.accent, textDecoration: "none" }}>
          Full analysis <ArrowRight size={14} />
        </Link>
      </div>
      {error && <p style={{ margin: 0, fontSize: 13, color: tokens.negative }}>Couldn't load your spending. Try again in a moment.</p>}
      {!error && !bills && <p style={{ margin: 0, fontSize: 13, color: tokens.textMuted }}>Loading…</p>}
      {bills && <ExpenseAnalysis bills={bills} budgets={budgets} compact />}
    </section>
  );
};

export default SpendingAnalysisCard;
